import { useTranslation } from "react-i18next";
import { useCallback, useState } from "react";
import Dialog from "components/common/Dialog/Dialog";
import Button from "components/common/Button/Button";
import {
  ContainerButtonStyle,
  DeleteButtonsStyle,
} from "./DuplicatePromotionFlash.style";
import { duplicateFlashPromotion } from "../../../UpdatedFeatures/api";
import { IPromotionFlashDuplicate } from "./DuplicatePromotionFlash.types";
import { useSnackBar } from "hooks/useSnackBar";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

function DuplicatePromotionFlash({
  id,
  product_id,
  date_promotion,
  percentage,
  openDuplicateDialog,
  setOpenDuplicateDialog,
  getDuplicatedFlashAfterUpdate,
  refetch
}: IPromotionFlashDuplicate) {
  const { t } = useTranslation();
  const [duplicatedFlash, setDuplicatedFlash] = useState<any>({id: id, product_id: product_id, date_promotion: date_promotion, percentage: percentage});
  const [isLoading, setIsLoading] = useState(false);

  const { displaySuccessSnackBar, displayErrorApiSnackBar } = useSnackBar();

  const closeDuplicateAlertDialog = useCallback(() => {
    setOpenDuplicateDialog(false);
  }, [setOpenDuplicateDialog]);

  const onSuccessDuplicateAlert = async (event: React.FormEvent) => {
    event.preventDefault();
    setIsLoading(true);
    
    try {
      await duplicateFlashPromotion(id);
      displaySuccessSnackBar(t("promotion_flash.successfully_duplicated"));
      getDuplicatedFlashAfterUpdate(undefined);
      refetch(); // Refetch to update the list with the new duplicate
      closeDuplicateAlertDialog();
    } catch (error: any) {
      displayErrorApiSnackBar(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog
      open={openDuplicateDialog}
      handleClose={closeDuplicateAlertDialog}
      title={t("promotion_flash.duplicate")}
      size={"xs"}
    >
      <div style={{textAlign: "center"}}> 
        <ContentCopyIcon sx={{fontSize:"90PX",color:"#b269ae"}} />
      </div>

      <form onSubmit={onSuccessDuplicateAlert}>
        <p>
          {t("common.duplicate_message")}
          <span style={{ fontWeight: "bold", marginLeft: 5 }}>{`Promotion Flash ${id}`}</span>?
        </p>
        <DeleteButtonsStyle>
          <ContainerButtonStyle>
            <Button
              disabled={isLoading}
              title={t("common.cancel_button")}
              onClick={closeDuplicateAlertDialog}
            />
          </ContainerButtonStyle>
          <ContainerButtonStyle>
            <Button
              disabled={isLoading}
              type="submit"
              loader={isLoading}
              title={t("common.confirm_button")}
            />
          </ContainerButtonStyle>
        </DeleteButtonsStyle>
      </form>
    </Dialog>
  );
}

export default DuplicatePromotionFlash;



